import axios from '@dap/shared-utils/http.js';

export default {
    getTiktokAudienceDict () {
        return axios.get('/dapper/api/aud/tiktok/dict');
    },
    updateTiktokAudience (params) {
        return axios.post('/dapper/api/aud/tiktok', params, {
            headers: { 'Content-Type': 'application/json' },
        });
    },
    getTiktokAudienceDetail (params) {
        return axios.get('/dapper/api/aud/tiktok', { params });
    },
    getTiktokAudienceList (params) {
        return axios.get('/dapper/api/aud/tiktok/list', { params });
    },
    updateTiktokStatus (params) {
        return axios.put('/dapper/api/aud/tiktok/status', params);
    },
    getTiktokAudienceLog (params) {
        return axios.get('/dapper/api/aud/tiktok/log', { params });
    },
    getRecommendInterest (params) {
        return axios.get('/dapper/api/aud/tiktok/interest_keyword/recommend', {
            params,
        });
    },
    getRecommendHashtag (params) {
        return axios.get('/dapper/api/aud/tiktok/hashtag/recommend', {
            params,
        });
    },
    checkName (params) {
        return axios.get('/dapper/api/aud/tiktok/check_name', { params });
    },
};
